import Box from '@mui/material/Box'

const NoRowsErrorOverlay = ({
    error,
}: { error: string }) => {
    // TODO-AM: investigate why we do not show error, what error type

    const message = (error && 'Something went wrong and the data could not be loaded.')
        || 'There is no data in this table yet'

    return (
        <Box
            sx={{
                mt: 2,
                display: 'flex',
                justifyContent: 'center',
            }}
            data-testid="no-rows-error-overview"
        >
            {message}
        </Box>
    )
}

export default NoRowsErrorOverlay
